/* import */
import imageCompression from 'browser-image-compression';

/**
 * Get Compress Image File
 * 画像サイズを1MB以下に圧縮する
 */
async function getCompressImageFile(file) {
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1024,
    };
    
    return imageCompression(file, options).catch(
      function() {
        return null;
      }
    );
}
export default {
  getCompressImageFile,
};
